import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { DurcharbeiteView } from '../components/expenses/DurcharbeiteView';
import { AnimationContextProvider } from '../hooks/useAnimationEnabled';
import { progressKey } from '../components/expenses/durcharbeite-progress';
import { useSession } from '../hooks/useTenantContext';
export const Route = createFileRoute('/expenses_/durcharbeite')({
  validateSearch: z.object({ expenseId: z.string().uuid().optional() }),
  component: DurcharbeitePage,
});
function DurcharbeitePage() {
  const { expenseId } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { data: session } = useSession();
  const tenant = session?.availableTenants.find((row) => row.tenantId === session.activeTenantId);
  const onNavigate = useCallback(
    (id: string | null) => {
      void navigate({ search: { expenseId: id ?? undefined }, replace: true });
    },
    [navigate]
  );
  return (
    <ProtectedRoute>
      <AnimationContextProvider context="durcharbeite">
        <DurcharbeiteView
          key={`${session?.user.id}:${session?.activeTenantId}`}
          progressStorageKey={
            session?.activeTenantId
              ? progressKey(session.user.id, session.activeTenantId)
              : undefined
          }
          activeId={expenseId}
          onNavigate={onNavigate}
          contextLabel={tenant?.name}
        />
      </AnimationContextProvider>
    </ProtectedRoute>
  );
}
